/* eslint-disable import/prefer-default-export */
import type { FormikHelpers, FormikConfig, FormikErrors } from 'formik'
import { validatePassword } from '@src/utils/validation'
import type { AccountInfoFormActions } from '../components'
import type { AccountInfoState } from '..'
import type { StepProps } from '../../models'
import { toastSuccess } from '@src/utils/toast'

export interface AccountInfoValues {
  firstName?: string
  lastName?: string
  email?: string
  oldPassword?: string
  newPassword?: string
  location?: string
  jobTitle?: string
}

export interface GetAccountInfoConfig {
  initialValues: AccountInfoValues
  stepProps: StepProps
  state: AccountInfoState
  actions: AccountInfoFormActions
}

export const updateUserCallback = (stepProps: StepProps): void => {
  if (
    stepProps?.steps &&
    stepProps?.stepId &&
    typeof stepProps?.switchStep === 'function'
  ) {
    if (stepProps?.steps[stepProps?.stepId + 1]) {
      stepProps.switchStep(stepProps?.stepId + 1)
    }
  } else {
    toastSuccess('User data has been changed')
  }
}

export const getAccountInfoConfig = ({
  initialValues,
  stepProps,
  state,
  actions
}: GetAccountInfoConfig): FormikConfig<AccountInfoValues> => ({
  initialValues,
  enableReinitialize: true,
  onSubmit: (
    values: AccountInfoValues,
    formikHelpers: FormikHelpers<AccountInfoValues>
  ) => {
    const { user = {} } = { ...stepProps }
    user.first_name = values?.firstName || 'none'
    user.last_name = values?.lastName || 'none'
    user.role = values?.jobTitle || 'none'
    actions.changePassword(values?.oldPassword, values?.newPassword)
    stepProps.updateUser(user, () => {
      updateUserCallback(stepProps)
    })
  },
  validate: (values: AccountInfoValues) => {
    const errors: FormikErrors<AccountInfoValues> = {}
    const { oldPassword, newPassword } = values
    if (newPassword) {
      if (oldPassword) {
        const oldPassMessage = validatePassword(oldPassword)
        if (oldPassMessage) {
          errors.oldPassword = oldPassMessage
        }
      } else {
        errors.oldPassword = 'Old password should be filled in'
      }

      const newPassMessage = validatePassword(newPassword)
      if (newPassMessage) {
        errors.newPassword = newPassMessage
      }
    }
    return errors
  }
})
